import PropTypes from "prop-types";
import Button from "./Button";
import FontAwesome from "../../icon/FontAwesome";
import { Icon } from "@mui/material";

const ButtonSign = (props) => {
  const { children, className, ...attribute } = props;
  return (
    <Button
      id="testButton"
      color="green"
      {...{ ...attribute, className: className + " tooltip-button" }}
    >
      <span className="tooltiptext">Ký số</span>
      <Icon>draw</Icon>
      {children}
    </Button>
  );
};

ButtonSign.propTypes = {
  children: PropTypes.any,
};

ButtonSign.defaultProps = {};

export default ButtonSign;
